export default 'https://webview.canny.io?boardToken=YOUR_BOARD_TOKEN&ssoToken=';
